/**
 * Hook to check if the multi-file media uploader feature is enabled via LaunchDarkly feature flag.
 *
 * @returns {boolean} true if the multi-file uploader feature is enabled, false otherwise
 *
 * @example
 * ```tsx
 * const isEnabled = useMultiFileUploaderFlag();
 * if (isEnabled) {
 *   return <UniversalMediaUploader />;
 * }
 * return <LegacyMediaUpload />;
 * ```
 */

export const MULTI_FILE_MEDIA_UPLOADER_FLAG = 'multi-file-media-uploader';

// eslint-disable-next-line max-len
export const useMultiFileUploaderFlag = (): boolean => !!globalThis.Fulcrum?.globals?.ldflags?.[MULTI_FILE_MEDIA_UPLOADER_FLAG];
